import React from "react";
import { PlusOutlined } from "@ant-design/icons";
import "./GalleryLabelTab.css";


const GalleryTabStrip = ({ items, activeKey, onChange, onAdd, canAdd }) => (
  <div className="gallery-tab-strip" role="tablist">
    {items.map((tab) => (
      <button
        key={tab.key}
        type="button"
        role="tab"
        aria-selected={activeKey === tab.key}
        className={`gallery-tab-strip-item${
          activeKey === tab.key ? " is-active" : ""
        }`}
        onClick={() => onChange(tab.key)}
      >
        {tab.label}
      </button>
    ))}
    {canAdd && (
      <button
        type="button"
        className="gallery-tab-strip-add"
        aria-label="Add label"
        onClick={onAdd}
      >
        <PlusOutlined />
      </button>
    )}
  </div>
);

export default GalleryTabStrip;
